import {FormikHelpers} from 'formik';
import {notify} from '@gemcook/notification';

import resources from '@resources';
import paths from '@paths';
import api from '@api';
import constants from '@constants';
import utils from '@utils';

import {Props} from './types';

export const update = async (
  props: Props,
  values: any,
  formikHelpers: FormikHelpers<any>,
  action: UsersAction & MeAction,
  id: string
) => {
  try {
    const birthdate = resources.users.getBirthDate(
      values.birthyear,
      values.birthmonth,
      values.birthday
    );

    await action.users.updateUser({...values, birthdate}, id);
    // 自分を編集した場合Meを更新する
    if (props.users.detail.id === props.me.id) {
      await action.me.updateMe();
    }
    props.history.push(`${paths.users.detail}/${id}`);
    switch (props.users.detail.authLevel) {
      case constants.AUTHORITIES.ADMIN:
        notify(
          resources.users.getNotifyMessage('success', 'update', 'admin'),
          'success'
        );
        break;
      case constants.AUTHORITIES.SUPER_ADMIN:
        notify(
          resources.users.getNotifyMessage('success', 'update', 'superAdmin'),
          'success'
        );
        break;

      default:
        notify(
          resources.users.getNotifyMessage('success', 'update', 'user'),
          'success'
        );
        break;
    }

    formikHelpers.setSubmitting(false);
  } catch (error) {
    switch (error.response.data.message) {
      case 'UsernameExistsException: An account with the given email already exists.':
        {
          notify(constants.ERRORS.EXISTED_EMAIL, 'error');
        }
        break;
      case 'email is not unique': {
        notify(constants.ERRORS.EXISTED_EMAIL_TEAM, 'error');
        break;
      }
      case 'phoneNumber is not unique': {
        notify(constants.ERRORS.EXISTED_PHONE_NUMBER, 'error');
        break;
      }

      default:
        notify(
          resources.users.getNotifyMessage('error', 'update', 'user'),
          'error'
        );
        break;
    }

    formikHelpers.setSubmitting(false);
  }
};

export const deleteUser = async (
  props: Props,
  id: string,
  me: MeStore,
  setDeleteLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setDeleteLoading(true);
  try {
    await props.actions.users.deleteUser(id);

    await utils.stripe.updateUsage(me);

    props.history.push(paths.users.main);
    if (props.users.detail.authLevel === constants.AUTHORITIES.ADMIN) {
      notify(
        resources.users.getNotifyMessage('success', 'delete', 'admin'),
        'success'
      );
    } else {
      notify(
        resources.users.getNotifyMessage('success', 'delete', 'user'),
        'success'
      );
    }
  } catch (error) {
    notify(
      resources.users.getNotifyMessage('error', 'delete', 'user'),
      'error'
    );
  } finally {
    setDeleteLoading(false);
  }
};

export const downgrade = async (
  detail: any,
  setDeleteLoading: any,
  setIsDeleteModal: any,
  actions: any,
  history: any
) => {
  setDeleteLoading(true);

  try {
    await api.users.downgrade(detail.id);
    const body: UserUpdateBody = {
      sub: '',
      cognitoUserName: '',
      authLevel: 0,
    };

    actions.users.updateUser(body, detail.id);

    history.goBack();
    setIsDeleteModal(false);

    notify('ユーザーの権限を一般権限に変更しました', 'success');
  } catch (error) {
    notify('一般ユーザーへの変更に失敗しました', 'error');
  } finally {
    setDeleteLoading(false);
  }
};
